// apps/web/src/App.tsx
//
// Top-level app shell. The smoke test imports AppRoutes (the bare <Routes>
// tree) directly so it can wrap it in MemoryRouter without contending with
// createBrowserRouter's window.history coupling. Production mount goes through
// AppRouter (createBrowserRouter + RouterProvider).
import { AppRouter } from "./router";

export function App() {
  return <AppRouter />;
}
